// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__2Lf63","cta":"Button_cta__1Lc7U","small":"Button_small__1WqE1","link":"Button_link__Kr8EU"};